/**
 * Events Data
 * 
 * Complete hierarchical data structure for Events section
 */
export const eventsData = [
  {
    marketId: 1,
    enabled: false,
    name: 'Politics',
    tree: [
      {
        marketId: 1,
        submarketId: 12,
        enabled: false,
        name: 'Bihar Election 2025',
        subtree: [
          {
            name: 'Bihar Election 2025',
            matches: [
              {
                title: 'Match',
                evnets: [
                  { name: 'Over', enabled: false },
                  { name: 'Under', enabled: false }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    marketId: 2,
    enabled: false,
    name: 'Cricket',
    tree: [
      {
        marketId: 2,
        submarketId: 1,
        enabled: false,
        name: 'Nepal Premier League',
        subtree: [
          {
            name: 'Biratnagar Kings v Lumbini Lions',
            matches: [
              {
                title: 'Match',
                evnets: [
                  { name: 'TIED_MATCH', enabled: false },
                  { name: 'MATCH_ODDS', enabled: false },
                  { name: 'fancy1', enabled: false },
                  { name: 'fancy1', enabled: false },
                  { name: 'oddeven', enabled: false },
                  { name: 'oddeven', enabled: false }
                ]
              }
            ]
          },
          {
            name: 'Pokhara Avengers v Kathmandu Gurkhas',
            matches: [
              {
                title: 'Match',
                evnets: [
                  { name: 'MATCH_ODDS', enabled: false },
                  { name: 'fancy1', enabled: false }
                ]
              }
            ]
          },
          {
            name: 'Sudurpaschim Royals v Chitwan Rhinos',
            matches: [
              {
                title: 'Match',
                evnets: [
                  { name: 'MATCH_ODDS', enabled: false }
                ]
              }
            ]
          }
        ]
      },
      {
        marketId: 2,
        submarketId: 2,
        enabled: false,
        name: 'International League T20',
        tree: []
      },
      {
        marketId: 2,
        submarketId: 3,
        enabled: false,
        name: 'T5 XI',
        tree: []
      },
      {
        marketId: 2,
        submarketId: 4,
        enabled: false,
        name: 'WBBL',
        tree: []
      },
      {
        marketId: 2,
        submarketId: 5,
        enabled: false,
        name: 'The Ashes',
        tree: []
      },
      {
        marketId: 2,
        submarketId: 6,
        enabled: false,
        name: 'The Ashes 2025 - 2026',
        tree: []
      },
      {
        marketId: 2,
        submarketId: 7,
        enabled: false,
        name: 'Test Matches',
        tree: []
      },
      {
        marketId: 2,
        submarketId: 8,
        enabled: false,
        name: 'Virtual Cricket League',
        tree: []
      },
      {
        marketId: 2,
        submarketId: 9,
        enabled: false,
        name: 'One Day Internationals',
        tree: []
      },
      {
        marketId: 2,
        submarketId: 10,
        enabled: false,
        name: 'Womens International Twenty20 Matches',
        tree: []
      },
      {
        marketId: 2,
        submarketId: 11,
        enabled: false,
        name: 'T10 XI',
        tree: []
      },
      {
        marketId: 2,
        submarketId: 12,
        enabled: false,
        name: 'testing',
        tree: []
      }
    ]
  },
  {
    marketId: 3,
    enabled: false,
    name: 'Football',
    tree: [
      {
        marketId: 3,
        submarketId: 1,
        enabled: false,
        name: 'Premier League',
        subtree: [
          {
            name: 'Manchester United v Liverpool',
            matches: [
              {
                title: 'Match',
                evnets: [
                  { name: 'MATCH_ODDS', enabled: false },
                  { name: 'OVER_UNDER', enabled: false }
                ]
              }
            ]
          }
        ]
      },
      {
        marketId: 3,
        submarketId: 2,
        enabled: false,
        name: 'La Liga',
        tree: []
      },
      {
        marketId: 3,
        submarketId: 3,
        enabled: false,
        name: 'Serie A',
        tree: []
      }
    ]
  },
  {
    marketId: 4,
    enabled: false,
    name: 'Tennis',
    tree: [
      {
        marketId: 4,
        submarketId: 1,
        enabled: false,
        name: 'ATP Tour',
        subtree: [
          {
            name: 'Wimbledon 2025',
            matches: [
              {
                title: 'Match',
                evnets: [
                  { name: 'MATCH_ODDS', enabled: false },
                  { name: 'SET_BETTING', enabled: false }
                ]
              }
            ]
          }
        ]
      },
      {
        marketId: 4,
        submarketId: 2,
        enabled: false,
        name: 'WTA Tour',
        tree: []
      }
    ]
  },
  {
    marketId: 5,
    enabled: false,
    name: 'Horse Racing',
    tree: [
      {
        marketId: 5,
        submarketId: 1,
        enabled: false,
        name: 'UK Racing',
        subtree: [
          {
            name: 'Ascot',
            matches: [
              {
                title: 'Race',
                evnets: [
                  { name: 'WIN', enabled: false },
                  { name: 'PLACE', enabled: false }
                ]
              }
            ]
          }
        ]
      },
      {
        marketId: 5,
        submarketId: 2,
        enabled: false,
        name: 'US Racing',
        tree: []
      }
    ]
  },
  {
    marketId: 6,
    enabled: false,
    name: 'Greyhound Racing',
    tree: [
      {
        marketId: 6,
        submarketId: 1,
        enabled: false,
        name: 'UK Greyhounds',
        subtree: [
          {
            name: 'Belle Vue',
            matches: [
              {
                title: 'Race',
                evnets: [
                  { name: 'WIN', enabled: false },
                  { name: 'PLACE', enabled: false }
                ]
              }
            ]
          }
        ]
      }
    ]
  },

]

